<template>
  <div />
</template>

<script>
import moment from 'moment'
import auth from '@/composables/auth'
import apiReferensi from '@/composables/referensi'
import { propsString } from '@/utils/propsTipeData'
import hakAkses from '@/utils/hakAkses'

export default {
  props: {
    kolok: propsString,
    jabatan: propsString,
  },
  created() {
    const username = `${this.$props.kolok}${this.$props.jabatan}`
    // const token = this.$route.query.token ?? null
    // const tahun = this.$route.query.tahun ?? null
    // this.$cookies.set('token', token)
    this.$cookies.set('username', username)
    // this.$cookies.set('tahun', tahun)

    const getTahunSensus = kib => apiReferensi.getTahunSensus(this, { kib })

    const getData = async () => {
      const params = {
        username,
        tahun: moment().format('YYYY'),
      }
      const resUserData = await auth.getUserData(this, params)

      let kolok = ''
      let nalok = ''
      let jenisAkun = ''
      let wilayah = ''

      if (resUserData.data) {
        kolok = resUserData.data.kolok
        nalok = resUserData.data.nalok
        jenisAkun = resUserData.data.jenis_akun
        wilayah = resUserData.data.id_wilayah
      } else if (resUserData.messsage == 'User Merupakan Admin') jenisAkun = 'admin'

      let filterWilayahPerkin = []

      if (jenisAkun == 'admin') {
        filterWilayahPerkin = [0, 1, 2, 3, 4, 5, 6]
      } else if (jenisAkun == 'pelaksana-suban') {
        kolok = ''
        nalok = ''
      }

      if (!hakAkses[jenisAkun] || !['development', 'staging'].includes(process.env.VUE_APP_ENV)) {
        this.$cookies.set('username', '')
        this.$router.push({ name: 'login' })
      }

      const userData = {
        ability: hakAkses[jenisAkun],
      }

      localStorage.setItem('userData', JSON.stringify(userData))
      this.$ability.update(userData.ability)

      this.$cookies.set('kolok', kolok)
      this.$cookies.set('nalok', nalok)
      this.$cookies.set('jenisAkun', jenisAkun)
      this.$cookies.set('wilayah', wilayah)
      this.$cookies.set(
        'filterWilayahPerkin',
        JSON.stringify(filterWilayahPerkin),
      )
      this.$cookies.set(
        'kib',
        'B',
      )

      const result = await getTahunSensus('B')
      this.$cookies.set('listTahun', JSON.stringify(result.rows))

      if (process.env.VUE_APP_ENV == 'development') window.location.href = '/b'
      else if (process.env.VUE_APP_ENV == 'staging') window.location.href = '/inventarisasi/st/b'
      else window.location.href = '/inventarisasi/pr/b'
      // this.$router.push({ name: 'cDashboard' })
    }
    getData()
  },
}
</script>
